import { useGetContactAddressQuery } from "../features/contact/contactApi";

export default function GoogleMap() {
  const { data: contactAddressData, isSuccess: isSuccessSingleData } = useGetContactAddressQuery();

  let content = "";
  if (isSuccessSingleData && contactAddressData) {
    content = <iframe className="embed-responsive-item" src={contactAddressData?.map} allowFullScreen="" />;
  }
  return (
    <div className="google-map">
      <div className="embed-responsive embed-responsive-21by9">{content}</div>
    </div>
  );
}
